export default {
  '@supabase/supabase-js': '^2.99.2'
}
